const DEFAULT_BASE_URL = "https://kewordal.local";

const DEFAULT_ALLOWED_PROTOCOLS = ["http:", "https:", "mailto:"];
const HTTP_PROTOCOLS = ["http:", "https:"];

const getBaseUrl = () =>
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : DEFAULT_BASE_URL;

const hasAbsoluteOrProtocolRelativeUrl = (value) =>
  /^[a-z][a-z\d+.-]*:/i.test(value) || value.startsWith("//");

const normalizeWindowFeatures = (features = "") => {
  const parts = String(features)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  const featureSet = new Set(parts);
  featureSet.add("noopener");
  featureSet.add("noreferrer");
  return Array.from(featureSet).join(",");
};

export const getSafeHref = (
  value,
  {
    allowRelative = true,
    allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS,
    fallback = "",
  } = {},
) => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return fallback;

  if (!hasAbsoluteOrProtocolRelativeUrl(rawValue)) {
    return allowRelative ? rawValue : fallback;
  }

  try {
    const parsedUrl = new URL(rawValue, getBaseUrl());
    return allowedProtocols.includes(parsedUrl.protocol) ? rawValue : fallback;
  } catch {
    return fallback;
  }
};

export const getSafeExternalUrl = (value, fallback = "") =>
  getSafeHref(value, {
    allowRelative: false,
    allowedProtocols: HTTP_PROTOCOLS,
    fallback,
  });

export const openSafeExternalUrl = (
  value,
  target = "_blank",
  features = "noopener,noreferrer",
) => {
  const safeUrl = getSafeExternalUrl(value);
  if (!safeUrl || typeof window === "undefined") return null;

  return window.open(safeUrl, target, normalizeWindowFeatures(features));
};
